import script from "./ChoseType.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoseType.vue?vue&type=script&setup=true&lang=js"

import "./ChoseType.vue?vue&type=style&index=0&id=390af5d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390af5d0"]])

export default __exports__